import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// import PelariHandal from "../../../assets/images/pelari-handal.png";
import API_URL from "../../../config/constant";

export default function Podium() {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);

    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/home?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.podium.data.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res.podium);
            } catch (error) {
                setData(t("home.podium", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <>
            <div className="w-full bg-podiumMobile md:bg-podium relative bg-top bg-cover bg-no-repeat min-h-screen xl:min-h-screen flex max-md:flex-wrap items-center">
                <div className="container mx-auto font-poppins text-white">
                    <div className="text-center md:text-left relative md:left-24">
                        <p className="text-8xl md:text-9xl text-brandYellow font-superWonder">{data?.title}</p>
                        <p className="text-2xl text-white px-3 py-1 bg-brandBlue rounded-lg w-fit font-bold relative -right-36" style={{ letterSpacing: '3px' }}>{data?.subTitle}</p>
                    </div>
                    <div className="flex items-center justify-center mt-12">
                        <div className="grid grid-cols-2 md:flex md:flex-row gap-x-4 md:gap-x-16 justify-center items-top md:items-center mx-4 md:mx-16 max-md:gap-y-4">
                            {data?.data.map((value, index) => (
                                <div className={`basis-full flex justify-center flex-wrap bg-white border-4 border-brandBlue rounded-3xl px-4 max-w-[240px] md:min-h-[200px]`} key={index}>
                                    <div className="text-center w-full border-b border-brandBlue">
                                        <p className="text-base md:text-xl text-brandBlue font-bold px-4 lg:px-8 py-2">{value.title}</p>
                                    </div>
                                    <div className="py-2 md:py-6 md:px-4 text-center rounded-b-lg font-normal font-poppins text-brandBlue text-xs">
                                        <p dangerouslySetInnerHTML={{ __html: value.desc }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
